import medicamento from '@/repositories/conecta-sus/cadastro/medicamento/medicamentoRepository'

export default baseUrl => {

    return {
        medicamento: medicamento(baseUrl),
    }
}